import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { DialogProvider, ToastProvider } from '@thefarmersfront/kitchen';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from './configs/queryClient';
import { PUBLIC_PATHS } from './constants/path';

import App from './App';
import { IS_MOCK_ENV, enableMocking } from './mocks/enableMocking';
import reportWebVitals from './reportWebVitals';
import { registerSW } from './serviceWorkerRegister';

import './assets/styles/default.scss';

async function bootstrap() {
  await enableMocking();

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ToastProvider>
          <DialogProvider>
            <App />
          </DialogProvider>
        </ToastProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );

  // 로그인 없이 외부 접근 가능한 경로에서는 서비스 워커 등록을 건너뛴다.
  // - 메인 화면(origin)으로의 강제 리다이렉트 방지
  // - 알림 권한 요청 및 거부 alert 노출 방지
  if (!IS_MOCK_ENV && !PUBLIC_PATHS.includes(window.location.pathname)) {
    registerSW();
  }

  reportWebVitals();
}

bootstrap();
